<div class="top-bar">
	<div class="users content-container recent-users">
		<div *ngIf="viewToRender === 'username'">
			<div *ngIf="recentUsersNames.length === 0">
				<div class="t9 bold center">No users saved. Log in with password</div>
			</div>
			<div *ngIf="recentUsersNames.length > 0" class="center">
				<img class="pin-account-image" src="../../../assets/img/account_circle.svg">
				<span class="t9 bold select-user-text">Select your user</span>
			</div>

			<div *ngIf="!searchText">
				<div class="user-chips-list">

					<mat-chip-listbox>
						<mat-chip-option color="warn" *ngFor="let user of recentUsersNames; let i = index"
							(click)="selectUserName(user)">{{user}}</mat-chip-option>
					</mat-chip-listbox>
				</div>
			</div>

			<div class="user-chips-list" *ngIf="searchText">

				<mat-chip-listbox>
					<mat-chip-option color="warn" *ngFor="let user of filteredUserNames; let i = index" (click)="selectUserName(user)">
						<span [innerHTML]="user"></span>
					</mat-chip-option>
				</mat-chip-listbox>

				<div *ngIf="filteredUserNames.length === 0" class="no-users-container">
					<mat-chip-listbox>
						<mat-chip-option color="warn" (removed)="clearSearch()">{{searchText}}</mat-chip-option>
					</mat-chip-listbox>
				</div>

			</div>


			<div class="keyboard-container">
				<app-custom-keyboard #usernameKeyboard [template]="standardTemplate" [searchElements]="sorterUserNames"
					(typedValue)="usernameKeyboardInput($event)"></app-custom-keyboard>
			</div>
		</div>

		<div *ngIf="viewToRender === 'pin'">

			<mat-icon svgIcon="arrow-back" (click)="navigateBack()"></mat-icon>
			<div class="center enter-pin">
				<img class="pin-account-image" src="../../../assets/img/password-lock.svg">
				<span class="t9 bold select-user-text">Enter your pin</span>
			</div>
			
			<h1 [ngClass]="{'shake': pinError}" class="pin-entry">{{ pinEntry }}</h1>

			<div *ngIf="pinError" class="error-message">
				PIN is not correct.
			</div>


			<div class="keyboard-container">
				<app-custom-keyboard class="pinKeyboard" #pinKeyboard [template]="pinTemplate"
					(typedValue)="pinKeyboardInput($event)"></app-custom-keyboard>
			</div>
		</div>

		<div *ngIf="viewToRender === 'password'">
			<div class="header">
				<img class="account-image" src="../../../assets/img/account_circle.svg">
				<input #usernameInput spellcheck="false" class="input-container" placeholder="Username"
					(focus)="onUsernameFocus($event)" (input)="syncWithUsernameKeyboard()" (blur)="onUsernameBlur()"
					inputmode="none" type="search" autocomplete="off">
				<img *ngIf="showClearUsernameInput" class="clear-input-image" src="../../../assets/img/remove_user.svg"
					(click)="clearInput()">
				<img class="password-image" src="{{ passwordIcon }}">
				<input #passwordInput type="{{ inputtype }}" class="input-container"
					placeholder="{{ passwordPlaceholder }}" (focus)="onPasswordFocus($event)"
					(input)="syncWithPasswordKeyboard()" (blur)="onPasswordBlur()" inputmode="none" type="search" autocomplete="off">
				<span class="show-password-button">
					<button type="button" (click)="showPassword($event)">{{ passwordButtonText }}</button>
				</span>
			</div>
			<div *ngIf="passwordError" class="error-message">
				Invalid username or password
			</div>
		</div>
		<div *ngIf="!pinActive" class="sign-in-button">
			<button class="btn btn-primary btn-block" [disabled]="isButtonDisabled" (click)="passwordLogin()">
				SIGN IN
			</button>
		</div>
	</div>
</div>

<div class="keyboard-container">
	<app-custom-keyboard #usernameKeyboard [template]="standardTemplate" [searchElements]="sorterUserNames"
		[hidden]="!showUsernameKeyboard" (typedValue)="usernameKeyboardInput($event)"></app-custom-keyboard>
	<app-custom-keyboard #passwordKeyboard [template]="standardTemplate" [hidden]="!showPasswordKeyboard"
		(typedValue)="passwordKeyboardInput($event)"></app-custom-keyboard>
</div>